<script>
    import {onDestroy, onMount} from 'svelte';
    import {Route, navigateTo} from 'svelte-router-spa';
    import {PRConnect} from "@projectroom/ui-lib";
    import {messaging} from "./store/messaging-store";

    export let currentRoute;
    export let params = {};

    let messagingSubsc;
    let dropdownLink = false;
    let popupPosting = false;
    let popupDisposal = false;
    let isLatestUpdated = false;
    let pageUrl = `${location.origin}/event-pre/${currentRoute.namedParams.eventId}`;
    let qrUrl;
	let publishPageUrl = `${location.origin}/event/${currentRoute.namedParams.eventId}`;
    let successMesage;
    let botTitle = "";
    let autoSaveFlag = false;
	let previewFlag, postingFlag;

    onMount(() => {
        messagingSubsc = messaging.subscribe(message => {
            if (message.target === "EventBuilderLayout") {
                handleAutoSave();
            }
        });
    });
     
    onDestroy(() => {
        messagingSubsc();
    });

    const clickPosting = () => {
        popupPosting = false;
        postingFlag = true;
        let eventId = currentRoute.namedParams.eventId;
        PRConnect.send("/api/Event/postEvent", { id : eventId}, data => {
            if( data.header.status === "success") {
                console.log("Event post success");
            }
        });
    }

    const clickDisposal = () => {
        popupDisposal = false;
        let botId = currentRoute.namedParams.botId;
        PRConnect.send("/api/Post/disposalChangeBotData", {botId}, data => {
            if( data.header.status === "success") {
                console.log("disposalChangeBotData success", data);
                location.reload();
            }
        });
    }

    const clickCopy = (pageUrl) => {
        navigator.clipboard.writeText(pageUrl).then(
            () => {
                console.log("clipboard 복사 성공");
            },
        );
    }

    const handleAutoSave = () => {
        autoSaveFlag = true;
        setTimeout(()=> {
            autoSaveFlag = false;
        }, 1500);
    }

	const popupOrganize = () => {
		popupPosting = false;
		previewFlag = false
		postingFlag = false;
	}

</script>

<div class="wrap builder" on:click={popupOrganize}>
    <header class="header builder">
      <div class="inner builder">
        <div data-collapse="small" data-animation="default" data-duration="400" data-easing="ease" data-easing2="ease" data-doc-height="1" role="banner" class="avatalk-menu builder w-nav">
          <div class="logo-section-2">
            <div class="logo-2">
              <div class="avatalk-logo">
                <a class="avatalk-link" on:click={()=>navigateTo("/")}></a>
              </div>
            </div>
            <div class="avatalk-name">이벤트 관리자</div>
          </div>
          <div class="menu-section">
            <div class="menu">
              <div class="save-btn pointer" on:click={handleAutoSave}>
                {#if autoSaveFlag}
                <div class="spinner" />
                {/if}자동저장중
              </div>
              <div data-hover="false" data-delay="0" class="view-btn w-dropdown" style="" on:click|stopPropagation={()=>previewFlag = !previewFlag}>
                <div class="dropdown-toggle-4 w-dropdown-toggle" id="w-dropdown-toggle-0" aria-controls="w-dropdown-list-0" aria-haspopup="menu" aria-expanded="false" role="button" tabindex="0">
                  <div class="view-text">미리보기</div>
                </div>
				<nav class="w-dropdown-list" id="w-dropdown-list-0" aria-labelledby="w-dropdown-toggle-0" class:w--open={previewFlag} on:click|stopPropagation>
                  <div class="publishing-button-popup">
                    <div class="tab-text _12">아바톡 페이지 URL</div>
                    <div class="url-wrap">
                      <div class="link-url">
                        <input type="text" class="text-block-28 page-url" value={pageUrl ? pageUrl : ""} readonly>
                        <div class="link-icon pointer" on:click={()=>window.open(pageUrl,
                                                '_blank')}/>
                      </div>
                      <div class="copy-url" on:click={()=> clickCopy(pageUrl)}>
                        <div class="copy-icon"></div>
                        <div class="text-block-29">복사</div>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
              <div data-hover="false" data-delay="0" class="publishing-btn w-dropdown" style="">
                <div class="dropdown-toggle-4 w-dropdown-toggle" id="w-dropdown-toggle-1"  on:click|stopPropagation={()=> popupPosting = !popupPosting}>
                  <div class="publishing-text">게시하기</div>
                </div>
                <nav class="w-dropdown-list" id="w-dropdown-list-1" aria-labelledby="w-dropdown-toggle-1" class:w--open={postingFlag} on:click|stopPropagation>
                  <div class="publishing-button-popup">
                    <div class="tab-text _12">아바톡 페이지 URL</div>
                    <div class="url-wrap">
                      <div class="link-url">
                        <input type="text" class="text-block-28 page-url" value={publishPageUrl ? publishPageUrl : ""} readonly>
                        <div class="link-icon pointer" on:click={()=>window.open(publishPageUrl, '_blank')}/>
                      </div>
                      <div class="copy-url" on:click={()=> clickCopy(publishPageUrl)}>
                        <div class="copy-icon"></div>
                        <div class="text-block-29">복사</div>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
            </div>
            <div class="home-icon" on:click={()=>navigateTo("/main")}></div>
          </div>
        <div class="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div></div>
      </div>
    </header>
    <div class="ava-popup" class:flex={popupPosting}>
        <div class="popup-layer withdraw">
            <div class="titile-text popup">
                <div class="h1 margin20">변경사항을 게시하시겠습니까?</div>
                <div class="title-sub popup">게시하기 버튼을 누르면 해당 페이지에서 <br>작업한 변경내역들이 반영됩니다.</div>
            </div>
            <div class="popup-button">
                <a class="close-button w-button" on:click={()=> popupPosting = false}>취소</a>
                <a class="quit-button w-button" on:click|stopPropagation={clickPosting}>변경사항 게시하기</a>
            </div>
        </div>
    </div>
    <Route {currentRoute} {params} />
</div>
<style>
    .flex {
        display: flex;
    }
    .publishing-button-popup {
        right: 60%;
    }

    .page-url {
        width: inherit;
        overflow: hidden;
        text-overflow: ellipsis;
        outline: none;
        border: 0;
    }

    .link-icon {
        margin-right: 6px;
    }

    .page-url-panel {
        right: -60px;
    }

    .page-url {
        width: inherit;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .motion-plus-btn {
        width: 100%;
        justify-content: center;
        background-image: none;
    }
    .logo {
        display: block;
    }

    @keyframes spinner {
        to {
            transform: rotate(360deg);
        }
    }

    .spinner:before {
        position: absolute;
        left: 53px;
        content: '';
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        margin-left: -10px;
        border-radius: 50%;
        border-top: 2px solid #15C747;
        border-right: 2px solid transparent;
        animation: spinner .7s linear infinite;
        animation-iteration-count: 3;
    }

    .auto-save-btn {
        position: relative;
        display: flex;
        width: 108px;
        height: 30px;
        margin-right: 10px;
        margin-left: 0px;
        padding-right: 14px;
        padding-left: 10px;
        -webkit-box-pack: end;
        -webkit-justify-content: flex-end;
        -ms-flex-pack: end;
        justify-content: flex-end;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        border-style: solid;
        border-width: 2px;
        border-color: #E1F3E8;
        border-radius: 5px;
        background-color: #E1F3E8;
        background-position: 13% 50%;
        background-size: auto;
        background-repeat: no-repeat;
        font-family: 'Noto sans kr 400', sans-serif;
        background-image: url("/static/images/save-icon1.svg");
        color: cadetblue;
        font-weight: 900;
        font-size: 12px;
    }

    .auto-save-btn:hover {
        border-color: #15C747;
    }
    
    .delete-btn {
        width: 132px;
    }

    .delete-btn.active:hover {
        border-color: #e55e8a;
    }
    
    .header.builder {
        padding-top: 10px;
        padding-left: 20px;
    }
    .avatalk-menu.builder {
        align-items: inherit;
    }

    .avatalk-logo {
        display: block;
    }

	.save-btn {
		position: relative;
	}

    @media screen and (min-width: 1280px) {
    }
    
</style>